module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startup-container"
  }, [(_vm.screenConfig) ? _c('div', {
    staticClass: "screen-config-container"
  }, [((!_vm.isBookieIdSet || !_vm.isScreenNameSet) && _vm.screenConfig.mode === 'startup') ? _c('Settings') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'venue') ? _c('Venue') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'venuesmall') ? _c('VenueSmall') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'nextthree') ? _c('NextThree') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'results') ? _c('Results') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'brand') ? _c('Brand') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'four') ? _c('Four') : _vm._e(), _vm._v(" "), (_vm.$store.state.isLoading && !_vm.$store.state.refreshingPrice) ? _c('div', {
    staticClass: "screen-loading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--text"
  }, [_vm._v("\n            " + _vm._s(_vm.$store.state.screenLoadingMessage) + "\n          ")])])])]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040aa185","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Startup.vue
// module id = 225
// module chunks = 1